// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1384":"101e831f","3067":"b0ce431a","4737":"f20f2f7b","6187":"04d187e2","8245":"b0ce431a"}[chunkId] + ".chunk.css";
};